"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_select_1 = require("react-select");
const context_1 = require("./context");
const react_if_1 = require("react-if");
const useFetchMoreOnScroll_1 = require("./useFetchMoreOnScroll");
const utils_1 = require("../../utils");
exports.AVAILABLE_DELTA = 10;
const MenuListComp = react_select_1.components.MenuList;
exports.MenuList = (_a) => {
    var { children } = _a, menuListProps = tslib_1.__rest(_a, ["children"]);
    const innerRef = react_1.useRef(null);
    const [fetchMore, isVisible] = useFetchMoreOnScroll_1.useFetchMoreOnScroll(innerRef);
    const { hasMore, remainingAmount, showAsLoadingState, options, count, pageSize, result: { loading }, } = context_1.useOsmosysSelectBoxContext();
    return (react_1.default.createElement(MenuListComp, Object.assign({}, menuListProps, { innerRef: innerRef }),
        children,
        react_1.default.createElement("hr", { className: "mb-0 mt-2" }),
        react_1.default.createElement("p", { className: utils_1.classnames('my-2 text-center small text-small', isVisible ? 'text-dark' : 'text-muted') },
            react_1.default.createElement(react_if_1.Switch, null,
                react_1.default.createElement(react_if_1.Case, { condition: showAsLoadingState === true }, "Loading..."),
                react_1.default.createElement(react_if_1.Case, { condition: hasMore === true },
                    react_1.default.createElement("a", { href: "#", className: isVisible ? 'text-reset' : '', onClick: e => {
                            if (e && e.preventDefault) {
                                e.preventDefault();
                            }
                            fetchMore();
                        } },
                        react_1.default.createElement(react_if_1.When, { condition: loading },
                            "Loading ",
                            pageSize,
                            " more results..."),
                        react_1.default.createElement(react_if_1.When, { condition: !loading },
                            "Click to load ",
                            remainingAmount,
                            " more"))),
                react_1.default.createElement(react_if_1.Case, { condition: hasMore === false && options.length === 1 }, "1 out of 1 result loaded"),
                react_1.default.createElement(react_if_1.Case, { condition: hasMore === false },
                    "All ",
                    options.length,
                    " result",
                    count === 1 ? '' : 's',
                    " loaded"),
                react_1.default.createElement(react_if_1.Default, null,
                    "Loaded ",
                    options.length,
                    " out of ",
                    count,
                    " result",
                    count === 1 ? '' : 's')))));
};
//# sourceMappingURL=MenuList.js.map